export default "__VITE_ASSET__BFG7g6Lw__"